export class Company {
  //#region Required properties JSON
  name: string;
  primaryLogoUrl: string;
  secondaryLogoUrl: string;
  loginScreenUrl: string;
  //#endregion
}
